<template>
  <!-- <v-spacer v-if="this.component.name != 'NFeRecebidas' && this.component.name != 'CTE'"></v-spacer>
    <span
      style="margin-top: 9px;"
      v-if="this.component.name == 'NFeRecebidas' && this.component.tipo == 'emitida' && this.component.name != 'NFeRecebidas' && this.component.name != 'CTE'"
    ></span>
  <v-spacer v-if="this.component.name != 'NFeRecebidas' && this.component.name != 'CTE'"></v-spacer>-->
  <span style="display: flex;" v-if="component.enable.rangeDate">
    <v-flex
      xs6
      sm2
      md2
      class="rangeDate"
      d-flex
      v-for="(item,i)  in buttons"
      :key="i"
    >
      <v-btn
        slot="activator"
        outline
        color="teal"
        text-color="white"
        dark
        round
        :class="'d-inline-block'+ ' btn_'+item.value+'_'+component.name"
        @click.native="changeOptionData(item,$event)"
      >
        <template v-if="item.value == 'tudo'">
          <v-icon small color="teal" class="iconFiltrarRangedButtons">filter_list</v-icon>
        </template>
        <small>{{item.text}}</small>
      </v-btn>
    </v-flex>
  </span>
</template>
<script>
export default {
  props: ["component", "openFiltro", "buttons", "empresa", "table", "conta"],
  data: () => ({}),
  components: {},
  mounted: function() {
    this.$nextTick(function() {
      if (this.component.enable.rangeDate) {
        let btn = document.querySelector(
          `.btn_mesAtual_` + this.component.name
        );
        btn.classList.remove("v-btn--outline");
        btn.classList.remove("bg_white");
        btn.classList.remove("teal--text");
        btn.classList.add("teal");
        btn.classList.add("white--text");
      }
    });
  },
  watch: {},
  methods: {
    changeOptionData: function(item) {
      if (item.value == "tudo") {
        this.openPanelFiltro();
      }
      this.$emit("getDataBusca", item.value);
    },
    openPanelFiltro() {
      this.$emit("getOpenFiltro", this.openFiltro);
    }
  }
};
</script>
<style scoped>
.rangeDate .flex {
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnDias/BtnDias.vue